import { Box, Flex } from '@iheartjane/reefer';
import { Suspense, lazy } from 'react';

import { LoadingWrapper } from '@jane/shared/components';

import { selectIdentification } from '../../customer/redux/identification';
import { useCustomerSelector } from '../../customer/selectors';
import type { IdentificationProps } from './identification.types';
import { ValidationIcon } from './validationIcon';
import { WarningMessage } from './warningMessage';

/** Code splitting to load convertIfPDF/pdfjs only when called */
const IdentificationUploader = lazy(() =>
  import('./idUploader').then(({ IdentificationUploader }) => ({
    default: IdentificationUploader,
  }))
);

const uploaderLabel = (customLanguage?: string | null, side?: string): string =>
  `Upload ${customLanguage || `Card ${side}`}`;

export const MMJIdentification = ({
  showValidationErrors,
  valid,
  onIdUploadAttempt,
  onRemove,
  cardFrontComplianceLanguage,
  cardBackComplianceLanguage,
}: IdentificationProps) => {
  const { document, loading_mmj_card, loading_mmj_card_back } =
    useCustomerSelector(selectIdentification);

  return (
    <Suspense fallback={<LoadingWrapper isLoading />}>
      <Flex alignItems="center">
        <IdentificationUploader
          document={document}
          label={uploaderLabel(cardFrontComplianceLanguage, 'Front')}
          imageKey="mmj_card"
          inputName="mmj-card"
          isLoading={loading_mmj_card}
          valid={valid}
          showValidationErrors={showValidationErrors}
          onIdUploadAttempt={onIdUploadAttempt}
          onRemove={onRemove}
        />

        <Box ml={16}>
          <IdentificationUploader
            document={document}
            imageKey="mmj_card_back"
            inputName="mmj-card-back"
            label={uploaderLabel(cardBackComplianceLanguage, 'Back')}
            isLoading={loading_mmj_card_back}
            valid={valid}
            showValidationErrors={showValidationErrors}
            onIdUploadAttempt={onIdUploadAttempt}
            onRemove={onRemove}
          />
        </Box>
        {!!(document.mmj_card && document.mmj_card_back) && <ValidationIcon />}
      </Flex>
      {!(document.mmj_card || document.mmj_card_back) && (
        <Box mt={8}>
          <WarningMessage>ID required for discount</WarningMessage>
        </Box>
      )}
    </Suspense>
  );
};
